import { Component } from '@angular/core';

@Component({
  selector: 'spark-mpm-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class MpmContactUsComponent {
  constructor() {}
}
